import { Dispatch } from 'redux';
import {
  HIDE_FACE_CHECK_MODAL,
  IDENTITY_SESSION_ERROR,
  IDENTITY_SESSION_SET_LOADING,
  SHOW_FACE_CHECK_MODAL,
} from './actions';
import { ReduxAction } from '../actions';
import { Thunk } from '../thunk';
import { currentCourseSelectorJs } from '../Courses/selectors';
import { ResourceApi } from '../../resource/Resource';
import {
  IdentitySession,
  IdentitySessionResource,
  IdentitySessionResourceGetOrCreate,
  IdentitySessionResourceSkipFaceCheck,
} from '../../resource/IdentitySession/types';
import { IDENTITY_SESSION } from '../resourceNames';

export const showFaceCheckModal = (dispatch: Dispatch<ReduxAction>): void => {
  dispatch({
    type: SHOW_FACE_CHECK_MODAL,
  });
};

export const hideFaceCheckModal = (dispatch: Dispatch<ReduxAction>): void => {
  dispatch({
    type: HIDE_FACE_CHECK_MODAL,
  });
};

export const setLoading = (loading: boolean) => (
  dispatch: Dispatch<ReduxAction>
): void => {
  dispatch({
    type: IDENTITY_SESSION_SET_LOADING,
    loading,
  });
};

export const setError = (message: string | null) => (
  dispatch: Dispatch<ReduxAction>
): void => {
  dispatch({
    type: IDENTITY_SESSION_ERROR,
    message,
  });
};

export const checkIdentitySession = async (
  coursePath: string
): Promise<IdentitySession> => {
  const identitySession = await ResourceApi.execute<
    IdentitySessionResource,
    IdentitySessionResourceGetOrCreate
  >(IDENTITY_SESSION, 'getOrCreate', { coursePath });
  return identitySession;
};

export const skipFaceCheck = (): Thunk => async (
  dispatch,
  getState
): Promise<void> => {
  dispatch(setLoading(true));

  const course = currentCourseSelectorJs(getState());
  if (!course) {
    dispatch(setError('No course, please refresh page'));
    return;
  }

  try {
    await ResourceApi.execute<
      IdentitySessionResource,
      IdentitySessionResourceSkipFaceCheck
    >(IDENTITY_SESSION, 'skipFaceCheck', { coursePath: course.path });
    dispatch(hideFaceCheckModal);
  } catch {
    dispatch(setError('Unexpected error, please try again'));
  } finally {
    dispatch(setLoading(false));
  }
};
